import { render, staticRenderFns } from "./addRegister.vue?vue&type=template&id=1018b4d9&scoped=true&"
import script from "./addRegister.vue?vue&type=script&lang=js&"
export * from "./addRegister.vue?vue&type=script&lang=js&"
import style0 from "./addRegister.vue?vue&type=style&index=0&id=1018b4d9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1018b4d9",
  null
  
)

export default component.exports